import React, { ReactNode } from "react";
import { PInputTextStyle as S } from "./PInputText.style";
import { InputTextProps } from "primereact/inputtext";
import { useClassNames } from "hooks/useClassNames";

export const PInputText = React.forwardRef<
  HTMLInputElement,
  Omit<InputTextProps, "size"> & {
    iconLeft?: React.ReactNode;
    iconRight?: React.ReactNode;
    label?: string | ReactNode;
    invalid?: boolean;
    outerClassName?: string;
    size?: "small" | "medium" | "large";
  }
>((props, ref) => {
  const { iconLeft, iconRight, label, invalid, ...cleanProps } = props;
  const id = React.useId();

  const inputClassName = useClassNames(
    {
      "p-invalid": !!invalid,
      "p-inputtext-sm": props.size === "small",
      "p-inputtext-lg": props.size === "large",
    },
    props.className,
  );
  if (iconLeft || iconRight || label) {
    const className = useClassNames(
      {
        "p-input-icon-left": !!iconLeft,
        "p-input-icon-right": !!iconRight,
        "p-float-label p-float-label-custom": !!label,
      },
      props.outerClassName,
    );
    return (
      <div className={className}>
        {iconLeft || null}
        <S.PInputText autoComplete="off" id={id} {...cleanProps} className={inputClassName} ref={ref} />
        {iconRight || null}
        <label htmlFor={id || cleanProps.id}>{label}</label>
      </div>
    );
  }
  return <S.PInputText autoComplete="off" {...cleanProps} className={inputClassName} ref={ref} />;
});
